






























import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import Share from './Share.vue'
import GProgress from './Progress.vue'
import { getInventLink } from '@/apps/index/models/api'
import { sa } from '@/utils/sa'

@Component({
  components: { Share, GProgress }
})
export default class Inventation extends Vue {
  public visible = false
  public link = ''
  public inventCount = 0
  @Emit()
  showInfo() {
    this.visible = false
    return this.link
  }
  @Emit()
  shareToWx() {
    this.visible = false
    return this.link + '&style="wx"'
  }
  @Watch('visible')
  onVisibleChange(val) {
    if (val) {
      this.obtainLink()
      setTimeout(() => {
        sa.track('ContentRepository_Share', {
          action: '打开分享'
        })
      }, 50)
    }
  }
  // methods
  public async obtainLink() {
    let data = await getInventLink({ register_url: location.origin + '/search' })
    console.log(data)
    if (data.success) {
      this.inventCount = data.invited_num
      this.link = data.url
    } else {
      this.inventCount = 0
      this.link = ''
    }
  }
}
